import * as Yup from "yup";
import { ISharedUserInfo } from "../../../services/medicationmanagement/medsUser/models/SharedUserInfo";

export const PrescirberSchema = Yup.object<Partial<Record<keyof ISharedUserInfo, Yup.AnySchema>>>({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  hpiiNumber: Yup.string()
    .required('HPI-I number is a required field')
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(16, "Must be exactly 16 digits")
    .max(16, "Must be exactly 16 digits"),
  prescriberNumber: Yup.string()
    .required('Prescriber number is a required field')
    .matches(/^[0-9]+$/, "Must be only digits")
    .max(7, "Must be less than or equal to 7 digits")
});

export const BasicUserSchema = Yup.object<Partial<Record<keyof ISharedUserInfo, Yup.AnySchema>>>({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required")
});
